export type Retentions = Record<string, number>

export const retentions = {
  month: 3.75,
  quarter: 2.5,
  week: 7.88,
  year: 1.41,
} satisfies Retentions
